import { Component, OnInit, Renderer2 } from '@angular/core';
import { ConfigService } from './Services/config.service';
import { LayoutService } from './Services/layout/layout.service';

@Component({
	selector: 'app-root',
	template: ` <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit {
	constructor(
		private layoutService: LayoutService,
		private configService: ConfigService,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.layoutService.globalAttributes.subscribe((data) => {
			const quantumMetricsURL = this.configService.getConfig().quantumMetrics;

			const script = this.renderer.createElement('script');
			script.src = quantumMetricsURL;
			script.async = true;

			// Append the script as the last child in <body>
			const body = this.renderer.selectRootElement('body', true);
			this.renderer.appendChild(body, script);
		});
	}
}
